// extracted by mini-css-extract-plugin
export default {"item":"head-item_item__rApIN"};